module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section id="MoxiGalleryContainer" style="display: none;">\n\n';
 if (data.listingid) { ;
__p += '\n\n  ';
 for (var i=0; i < data.medium.length; i++) { ;
__p += '\n\n    ';
 // Images
      if (data.medium[i].mime_type.indexOf('image/') > -1 && data.medium[i].urls) {
    ;
__p += '\n\n\n      <img\n        src="' +
((__t = ( data.medium[i].urls.thumb_url )) == null ? '' : __t) +
'"\n        data-image="' +
((__t = ( data.medium[i].urls.gallery_url )) == null ? '' : __t) +
'"\n        alt="' +
((__t = ( data.medium[i].title )) == null ? '' : __t) +
'"\n        data-description="' +
__e( data.medium[i].description ) +
'">\n\n\n\n    ';
 // Video
      } else if (data.medium[i].mime_type.indexOf('text/html') > -1 && data.medium[i].videoType !== 'custom') {
    ;
__p += '\n\n\n      <img\n        src="' +
((__t = ( data.medium[i].videoThumbSrc )) == null ? '' : __t) +
'"\n        data-image="' +
((__t = ( data.medium[i].videoThumbSrc )) == null ? '' : __t) +
'"\n        data-type="' +
((__t = ( data.medium[i].videoType )) == null ? '' : __t) +
'"\n        data-videoid="' +
((__t = ( data.medium[i].videoId )) == null ? '' : __t) +
'"\n        alt="' +
((__t = ( data.medium[i].title )) == null ? '' : __t) +
'"\n        data-description="' +
__e( data.medium[i].description ) +
'">\n\n\n    ';
 // Video
      } else if (data.medium[i].mime_type.indexOf('text/html') > -1 && data.medium[i].videoType === 'custom') {
    ;
__p += '\n\n    ';
 var embedded = data.medium[i].embedded.replace(/(width=")\d+("\W+height=")\d+/, '$1100%$2100%').replace(/"/g, "'") ;
__p += '\n\n      <img\n        src="' +
((__t = ( data.medium[i].videoThumbSrc )) == null ? '' : __t) +
'"\n        data-image="' +
((__t = ( data.medium[i].videoThumbSrc )) == null ? '' : __t) +
'"\n        data-type="' +
((__t = ( data.medium[i].videoType )) == null ? '' : __t) +
'"\n        data-videoid="' +
((__t = ( data.medium[i].videoId )) == null ? '' : __t) +
'"\n        data-description="' +
__e( data.medium[i].description ) +
'"\n        alt="' +
((__t = ( data.medium[i].title )) == null ? '' : __t) +
'"\n        data-custom="' +
((__t = ( embedded )) == null ? '' : __t) +
'">\n\n    ';
 // PDF
      } else if (data.medium[i].mime_type.indexOf('application/pdf') > -1) {
        var append = "<div class='gallery-open-pdf'><a href='" +  data.medium[i].urls.gallery_url + "' target='_blank'></a></div>"
        var thumb = (data.medium[i].special_thumb_url !== null) ? data.medium[i].special_thumb_url : "https://moxi1.ssl.hwcdn.net/img-pr/i/cd307f40199d8a5a373ba5e23a15b5fa2a4ca76c/0_3_full.png";
        var full = (data.medium[i].special_thumb_url !== null) ? data.medium[i].special_thumb_url.replace('thumb', 'full') : "https://moxi1.ssl.hwcdn.net/img-pr/i/cd307f40199d8a5a373ba5e23a15b5fa2a4ca76c/0_3_full.png";
    ;
__p += '\n\n\n      <img\n        src="' +
((__t = ( thumb )) == null ? '' : __t) +
'"\n        data-image="' +
((__t = ( full )) == null ? '' : __t) +
'"\n        alt="' +
((__t = ( data.medium[i].title )) == null ? '' : __t) +
'"\n        data-description="' +
__e( data.medium[i].description ) +
'"\n        data-append="' +
((__t = ( append )) == null ? '' : __t) +
'">\n\n\n    ';
 } ;
__p += '\n\n  ';
 } ;
__p += '\n\n';
 } ;
__p += '\n\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/templates/Gallery.ejs
// module id = 7
// module chunks = 0